import { render, staticRenderFns } from "./Retsept.vue?vue&type=template&id=100764ec"
import script from "./Retsept.vue?vue&type=script&lang=js"
export * from "./Retsept.vue?vue&type=script&lang=js"
import style0 from "./Retsept.vue?vue&type=style&index=0&id=100764ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports